// This will have different types on client and server.
let timeout: any = null;
export const debounce = (callback: () => void, ms: number) => {
    return () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            callback();
        }, ms);
    };
};
